import type { Lang } from '../../core/index.js';

const formatters = new Map<string, Intl.NumberFormat>();

/** Number in the app language: German with a decimal comma (93,0), English with a point (93.0). */
export function formatNumber(lang: Lang, value: number, digits = 1): string {
  const key = `${lang}:${digits}`;
  let f = formatters.get(key);
  if (!f) {
    f = new Intl.NumberFormat(lang === 'de' ? 'de-DE' : 'en-GB', {
      minimumFractionDigits: digits,
      maximumFractionDigits: digits,
      useGrouping: false,
    });
    formatters.set(key, f);
  }
  return f.format(value);
}

/** "93,0 °C" (non-breaking space before the unit). */
export function formatTemp(lang: Lang, value: number, digits = 1): string {
  return `${formatNumber(lang, value, digits)}\u00a0°C`;
}
